import { render, staticRenderFns } from "./VitalsChart.vue?vue&type=template&id=6ea024bc"
import script from "./VitalsChart.vue?vue&type=script&lang=js"
export * from "./VitalsChart.vue?vue&type=script&lang=js"
import style0 from "./VitalsChart.vue?vue&type=style&index=0&id=6ea024bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports